<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
// import Loader from "@/components/widgets/preloader";
import { mapState, mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import moment from "moment";

export default {
  page: {
    title: "Spoilt Stock",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    // Loader,
    ModelListSelect,
  },
  data() {
    return {
      title: "Spoilt Stock ",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Spoilt Stock",
          active: true,
        },
      ],

      clientCurrentPage: 1,
      clientPerPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      sortDesc: false,
      modal_id: "",

      dateError: "",
      quantityError: "",
      productError: "",

      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "Date",
        },
        {
          key: "product.product_name",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "qty",
          sortable: true,
          label: "QTY",
        },
        {
          key: "buyingprice",
          sortable: true,
          label: "BUYING PRICE",
        },
        {
          key: "batch",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "reason",
          sortable: true,
          label: "REASON",
        },
        {
          key: "user.name",
          sortable: true,
          label: "ADDED By",
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],

      fields1: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "Date",
        },
        {
          key: "productname",
          sortable: true,
          label: "PRODUCT",
        },
        {
          key: "qty",
          sortable: true,
          label: "QTY",
        },
        {
          key: "buyingprice",
          sortable: true,
          label: "BUYING PRICE",
        },
        {
          key: "total",
          sortable: true,
          label: "SUB TOTAL",
        },
        {
          key: "batch",
          sortable: true,
          label: "BATCH",
        },
        {
          key: "reason",
          sortable: true,
          label: "REASON",
        },
        {
          key: "user.name",
          sortable: true,
          label: "ADDED By",
        },
        {
          key: "branch.name",
          sortable: true,
          label: "BRANCH",
        },
      ],
      FBatches: [],

      // Value from user input for adding unit
      data: {
        product: "",
        batch: "",
        name: "",
        quantity: "",
        date: moment(new Date()).format("YYYY-MM-DD"),
        reason: "",
        category: 2,
      },
      // edit unit
      editdata: {
        name: "",
        category: "",
        id: "",
      },
      // delete unit
      deletedata: {
        name: "",
        id: "",
      },

      filterSpoilt: {
        branch_id: 0,
        search: "",
        page: 1,
        per_page: 10,
        category: 2,
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", ["type", "message", "show"]),
    ...mapGetters("consumables", [
      "Consumables",
      "SpoiltPaginated",
      "SpoiltPagination",
      "IsSpoiltServerPaginated",
      "FilterStatus",
      "SpoiltSummary",
      "CurrentSpoiltFilters",
    ]),
    ...mapGetters("stock", ["SaveStatus"]),
    ...mapGetters("consumables", ["Spoilt", "FilterStatus"]),
    ...mapGetters("products", ["Batches"]),
    ...mapGetters("auth", ["MyUserPerm", "branchid", "Branches"]),

    /**
     * Total no. of records
     */
    rows() {
      return this.IsSpoiltServerPaginated
        ? this.SpoiltPagination.total
        : this.SpoiltPaginated
        ? this.SpoiltPaginated.length
        : 0;
    },

    currentPage: {
      get() {
        return this.IsSpoiltServerPaginated
          ? this.SpoiltPagination.current_page
          : this.clientCurrentPage;
      },
      set(value) {
        if (this.IsSpoiltServerPaginated) {
          this.handlePageChange(value);
        } else {
          this.clientCurrentPage = value;
        }
      },
    },

    perPage: {
      get() {
        return this.IsSpoiltServerPaginated
          ? this.SpoiltPagination.per_page || this.filterSpoilt.per_page
          : this.clientPerPage;
      },
      set(value) {
        if (this.IsSpoiltServerPaginated) {
          this.filterSpoilt.per_page = value;
          this.handlePerPageChange(value);
        } else {
          this.clientPerPage = value;
        }
      },
    },

    isLoading() {
      return this.FilterStatus;
    },

    totalValue() {
      return this.SpoiltSummary ? this.SpoiltSummary.total_value : 0;
    },
  },
  watch: {
    show(newValue) {
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.type == "success") {
          Swal.fire("Success!", this.message.msg, "success");
        } else {
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchConsumables: "consumables/fetchConsumables",
      FetchBatches: "products/fetchBatches",
      FetchSpoiltData: "consumables/fetchSpoiltConsumables",
      AddSpoilt: "stock/addSpoilt",
      DeleteSpoilt: "stock/deleteSpoilt",
      FetchBranches: "auth/fetchBranches",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      if (!this.IsSpoiltServerPaginated) {
        this.clientCurrentPage = 1;
      }
    },

    handleServerSearch() {
      this.filterSpoilt.page = 1;
      this.FetchSpoiltData(this.filterSpoilt);
    },

    handlePageChange(newPage) {
      if (this.IsSpoiltServerPaginated) {
        this.filterSpoilt.page = newPage;
        this.FetchSpoiltData(this.filterSpoilt);
      }
    },

    handlePerPageChange(newPerPage) {
      if (this.IsSpoiltServerPaginated) {
        this.filterSpoilt.page = 1;
        this.filterSpoilt.per_page = newPerPage;
        this.FetchSpoiltData(this.filterSpoilt);
      }
    },

    calculateIndex(index) {
      if (this.IsSpoiltServerPaginated) {
        return this.SpoiltPagination.from - 1 + index;
      } else {
        return this.clientPerPage * (this.clientCurrentPage - 1) + index;
      }
    },

    FilterProducts() {
      this.filterSpoilt.page = 1;
      this.FetchSpoiltData(this.filterSpoilt);
    },

    addSpoilt(modalId) {
      this.modal_id = modalId;

      if (this.data.product === "") {
        this.productError = "Product  field is required";
        return;
      } else {
        this.productError = "";
      }

      if (this.data.date === "") {
        this.dateError = "Date field is required";
        return;
      } else {
        this.dateError = "";
      }

      if (this.data.quantity === "") {
        this.quantityError = "Quantity field is required";
        return;
      } else {
        this.quantityError = "";
      }
      this.validateQuantity();
      if (this.quantityError != "") {
        return;
      }
      this.AddSpoilt(this.data);
    },

    getBatches(){
      this.FBatches = this.Batches.filter((batch)=>{
        return batch.product_id == this.data.product && batch.category == 1;
      })
    },

    validateQuantity(){
      if (this.data.product !="" && this.data.quantity!=''){
        let selectedPdt = this.Consumables.filter((item)=>{
          return item.id == this.data.product;
        })
        let instock =selectedPdt[0].qty;
        if (instock<this.data.quantity){
          this.quantityError="Quantity Removed "+this.data.quantity+" cannot be greater than quantity in Stock "+instock;
        }
      }
    },

    resetAdd() {
      this.data.product = "";
      this.data.date = "";
      this.data.quantity = "";
      this.data.batch = "";
      this.data.reason = "";
      this.modal_id = "";
    },
    resetEdit() {
      this.data.product = "";
      this.data.date = "";
      this.data.quantity = "";
      this.data.batch = "";
      this.data.reason = "";
      this.modal_id = "";
    },

    resetDelete() {
      this.deletedata.name = "";
      this.deletedata.id = "";
      this.modal_id = "";
    },

    resetError() {
      this.productError = "";
      this.dateError = "";
      this.quantityError = "";
    },
    showEditModal(data) {
      this.editdata.name = data.item.productname;
      this.editdata.quantity = data.item.qty;
      this.editdata.reason = data.item.reason;
      this.editdata.id = data.item.id;
    },
    editProduct(modalId) {
      this.modal_id = modalId;
      this.EditProduct(this.editdata);
    },
    showDeleteModal(data) {
      this.deletedata.name = data.item.productname;
      this.deletedata.id = data.item.id;
    },
    deleteSpoilt(modalId) {
      this.modal_id = modalId;
      this.DeleteSpoilt(this.deletedata);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },

  created() {
    if (this.branchid == 0) {
      this.filterSpoilt.branch_id = 0;
    }
    this.filterSpoilt.per_page = this.perPage;
    this.FetchSpoiltData(this.filterSpoilt);
    this.FetchConsumables();
    this.FetchBatches();
    this.FetchBranches();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row" v-if="branchid == 0">
              <div class="col-md-8"></div>
              <div class="col-md-4 mb-3">
                <label>FILTER BY BRANCHES</label>
                <model-list-select
                  :list="Branches ? Branches : []"
                  v-model="filterSpoilt.branch_id"
                  option-value="id"
                  option-text="name"
                  placeholder="Select Branch"
                  @input="FilterProducts()"
                >
                </model-list-select>
              </div>
            </div>
            <div class="row">
              <div class="col-md-3">
                <h4 class="card-title">Spoilt Stock Report</h4>
              </div>
              <div class="col-md-3">
                <router-link :to="'/consumables/pendingspoilt'">
                  <b-button variant="primary">Pending Spoilt Stock</b-button>
                </router-link>
              </div>
              <div class="col-md-3">
                <router-link :to="'/consumables/rejectedspoilt'">
                  <b-button variant="primary">Rejected Spoilt Stock</b-button>
                </router-link>
              </div>
              <div
                v-if="MyUserPerm.record_spoilt_stock == 1 && branchid != 0"
                class="col-md-3"
                align="right"
              >
                <b-button v-b-modal.add-product-modal variant="primary"
                  ><i class="fa fa-plus"></i> Add New</b-button
                >
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-3 d-flex align-items-end">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center mb-0">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-4"></div>
              <div class="col-sm-12 col-md-5">
                <label>SEARCH SPOILT STOCK</label>
                <div class="input-group">
                  <b-form-input
                    v-model="filterSpoilt.search"
                    type="search"
                    placeholder="Search by product name, batch, reason..."
                    class="form-control form-control-sm"
                    @keyup.enter="handleServerSearch()"
                  ></b-form-input>
                  <div class="input-group-append">
                    <button
                      class="btn btn-primary"
                      type="button"
                      @click="handleServerSearch()"
                    >
                      <b-spinner
                        v-if="FilterStatus"
                        variant="light"
                        small
                        label="Searching"
                      ></b-spinner>
                      <span>Search</span>
                    </button>
                  </div>
                </div>
              </div>
              <!-- End search -->
            </div>

            <!-- Table -->
            <div class="table-responsive mb-0 mt-3">
              <div v-if="!IsSpoiltServerPaginated">
                <b-table
                  class="datatables"
                  :items="SpoiltPaginated ? SpoiltPaginated : []"
                  :fields="branchid == 0 ? fields1 : fields"
                  responsive="sm"
                  :per-page="clientPerPage"
                  :current-page="clientCurrentPage"
                  :sort-desc.sync="sortDesc"
                  @filtered="onFiltered"
                  show-empty
                  empty-text="No spoilt stock found."
                >
                  <template #cell(index)="data">
                    {{
                      clientPerPage * (clientCurrentPage - 1) + data.index + 1
                    }}
                  </template>
                  <template #cell(qty)="data">
                    {{ data.item.qty }} {{ data.item.unit }}
                  </template>
                  <template #cell(total)="data">
                    {{
                      (
                        data.item.qty *
                        data.item.buyingprice.replaceAll(/,/g, "")
                      ).toLocaleString()
                    }}
                  </template>

                  <template #cell(actions)="data">
                    <b-button
                      v-if="
                        data.item.expired != 1 &&
                        MyUserPerm.delete_spoilt_stock == 1
                      "
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-product-modal
                      @click="showDeleteModal(data)"
                      ><i class="fa fa-trash"></i
                    ></b-button>
                  </template>
                  <template #table-busy>
                    <div class="text-center text-warning my-2">
                      <b-spinner class="align-middle"></b-spinner>
                      <strong>Loading...</strong>
                    </div>
                  </template>
                </b-table>
              </div>

              <div v-else>
                <table
                  class="table table-striped table-bordered table-responsive nowrap w-100 datatables"
                >
                  <thead>
                    <tr>
                      <th
                        v-for="field in branchid == 0 ? fields1 : fields"
                        :key="field.key"
                      >
                        {{ field.label }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    v-if="
                      !FilterStatus &&
                      SpoiltPaginated &&
                      SpoiltPaginated.length > 0
                    "
                  >
                    <tr v-for="(item, index) in SpoiltPaginated" :key="item.id">
                      <td>{{ calculateIndex(index) + 1 }}</td>
                      <td>{{ item.date }}</td>
                      <td>
                        {{ item.productname }}
                      </td>
                      <td>{{ item.qty }} {{ item.unit }}</td>
                      <td>{{ item.buyingprice }}</td>
                      <td v-if="branchid == 0">
                        {{
                          (
                            item.qty * item.buyingprice.replaceAll(/,/g, "")
                          ).toLocaleString()
                        }}
                      </td>
                      <td>{{ item.batch }}</td>
                      <td>{{ item.reason }}</td>
                      <td>{{ item.user ? item.user.name : "N/A" }}</td>
                      <td v-if="branchid == 0">
                        {{ item.branch ? item.branch.name : "N/A" }}
                      </td>
                      <td>
                        <b-button
                          v-if="
                            item.expired != 1 &&
                            MyUserPerm.delete_spoilt_stock == 1
                          "
                          size="sm"
                          variant="danger"
                          v-b-modal.delete-product-modal
                          @click="showDeleteModal({ item: item })"
                          ><i class="fa fa-trash"></i
                        ></b-button>
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="FilterStatus">
                    <tr>
                      <td
                        :colspan="(branchid == 0 ? fields1 : fields).length"
                        class="text-center"
                      >
                        <div class="text-warning my-2">
                          <b-spinner class="align-middle"></b-spinner>
                          <strong>Loading...</strong>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tbody
                    v-if="
                      !FilterStatus &&
                      (!SpoiltPaginated || SpoiltPaginated.length === 0)
                    "
                  >
                    <tr>
                      <td
                        :colspan="(branchid == 0 ? fields1 : fields).length"
                        class="text-center"
                      >
                        No spoilt stock found.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="row text-center mt-3">
                <h5>Total Value: {{ totalValue.toLocaleString() }}</h5>
              </div>
            </div>
            <!--            <Loader v-if="isLoading && (!SpoiltPaginated || SpoiltPaginated.length === 0)"/>-->
            <div class="row mt-3">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                      aria-controls="spoilt-stock-table"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- All modals remain the same -->
    <b-modal id="add-product-modal" hide-footer @hidden="resetAdd">
      <template #modal-title> Add spoilt stock </template>
      <div class="form-group mb-3">
        <div class="form-group mb-3">
          <label>Product <span class="text-danger">*</span></label>
          <model-list-select
              :list="Consumables ? Consumables : []"
              v-model="data.product"
              option-value="id"
              option-text="name"
              class="mb-3"
              placeholder="Select Item"
              @input="resetError(),getBatches()"
          >
          </model-list-select>            
          <div class="text-danger" v-if="productError">
            <em>{{productError }}</em>
          </div>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Batch <span class="text-danger"></span></label>
        <model-list-select
          :list="FBatches ? FBatches : []"
          v-model="data.batch"
          option-value="id"
          option-text="batch_number"
          class="mb-3"
          placeholder="Select Batch"
          @input="resetError()"
        >
        </model-list-select>
      </div>

      <div class="form-group mb-3">
        <label>Quantity Removed <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="number"
            step="any"
            placeholder="Enter Quantity "
            class="form-control"
            @input="resetError(), validateQuantity()"
            v-model="data.quantity"
          />
        </div>
        <div class="text-danger" v-if="quantityError">
          <em>{{ quantityError }}</em>
        </div>
      </div>

      <div class="form-group mb-3">
        <label>Date Removed <span class="text-danger">*</span></label>
        <div class="input-group">
          <input
            type="date"
            placeholder="Enter Product Name"
            class="form-control"
            v-model="data.date"
            @input="resetError()"
          />
        </div>
        <div class="text-danger" v-if="dateError">
          <em>{{ dateError }}</em>
        </div>
      </div>
      <div class="form-group mb-3">
        <label>Reason <span class="text-danger"></span></label>
        <div class="input-group">
          <textarea
            placeholder="Enter Product Name"
            class="form-control"
            @input="resetError()"
            v-model="data.reason"
          />
        </div>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-danger"
          data-dismiss="modal"
          @click="closeModal('add-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button
          v-if="SaveStatus"
          type="button"
          class="btn btn-primary"
          disabled
        >
          <i class="fa fa-check"></i>
          Submit
          <b-spinner variant="light" small label="Spinning"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-primary"
          @click="addSpoilt('add-product-modal')"
        >
          <i class="fa fa-check"></i>
          Submit
        </button>
      </div>
    </b-modal>
    <!-- modal delete product starts -->
    <b-modal
      header-bg-variant="danger"
      header-text-variant="light"
      body-text-variant="danger"
      footer-bg-variant="danger"
      footer-text-variant="danger"
      id="delete-product-modal"
      hide-footer
      @hidden="resetDelete"
    >
      <template #modal-title> Delete Product {{ deletedata.name }}</template>
      <div class="form-group mb-3">
        <div class="input-group">
          <h5>
            Do you want to delete this record? Click Proceed Button to delete.
          </h5>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-secondary"
          data-dismiss="modal"
          @click="closeModal('delete-product-modal')"
        >
          <i class="fa fa-times"></i> Close
        </button>
        <button v-if="SaveStatus" type="button" class="btn btn-danger" disabled>
          <i class="fa fa-trash"></i> Proceed
          <b-spinner variant="light" small label="Deleting"></b-spinner>
        </button>
        <button
          v-else
          type="button"
          class="btn btn-danger"
          @click="deleteSpoilt('delete-product-modal')"
        >
          <i class="fa fa-trash"></i> Proceed
        </button>
      </div>
    </b-modal>
    <!-- modal ends -->
  </Layout>
</template>

<style>
.btn-primary {
  background-color: #fab031 !important;
  border-color: #fab031 !important;
}
</style>
